<script lang="ts" setup>
import { useElementHover } from '@vueuse/core';
import { useTemplateRef } from 'vue';
import { hasSlotContent } from '../../../utils';

const rootRef = useTemplateRef('root');

const isHovered = useElementHover(rootRef, {
  delayLeave: 50,
});
</script>

<template>
  <div ref="root" :class="$style.root">
    <slot />
    <div v-show="isHovered" v-if="hasSlotContent($slots.actions)" :class="$style.actions">
      <div :class="$style.actionsOuter">
        <div :class="$style.actionsInner">
          <slot name="actions" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.root {
  position: relative;
}

.actions {
  position: absolute;
  left: 0;
  top: 100%;
  width: 100%;
  z-index: 999;
  height: 0;
}

.actionsOuter {
  position: sticky;
  left: 0;
  padding: 4px 24px 0 48px;
  height: 24px;
  display: inline-block;
  vertical-align: top;
}

.actionsInner {
  display: inline-flex;
  border-radius: 10px;
  border: 1px solid #e4e5e8;
  background: #fff;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.08);
}
</style>
